import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { SubmitHandler } from "react-hook-form";
import { useEffect } from "react";

import { Button, Input } from "@chef/components";
import { useExtendedForm } from "@chef/hooks";
import { useSubmitGiftcardMutation } from "@chef/state-management";
import { useTrack } from "@chef/state-management/hooks";

import { intl } from "./Redeem.Intl";

export type IFormInput = yup.InferType<typeof schema>;

const schema = yup.object({
  giftCode: yup.string().required(intl.REQUIRED),
});

export const RedeemGiftcard = () => {
  const [
    submitGiftcardMutation,
    { error: errorSubmitGiftcard, isLoading, isSuccess },
  ] = useSubmitGiftcardMutation();

  const { register, handleSubmit, setError } = useExtendedForm<IFormInput>({
    resolver: yupResolver(schema),
  });

  const track = useTrack();

  const onSubmit: SubmitHandler<IFormInput> = async (data) => {
    const { giftCode } = data;

    try {
      await submitGiftcardMutation({
        giftCode,
      }).unwrap();
      track("giftcardAdded", {
        affiliation: "Frontend process",
        gift_card_code: giftCode,
      });
    } catch (err: any) {
      console.error(err);

      track("giftcardFailed", {
        affiliation: "Frontend process",
        gift_card_code: giftCode,
        giftcard_fail_reason: err?.data?.Message,
      });
    }
  };

  useEffect(() => {
    if (errorSubmitGiftcard) {
      setError("giftCode", {
        message: intl.INVALID_GIFTCARD_CODE,
      });
    }
  }, [errorSubmitGiftcard, setError]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex">
      <div className="flex flex-1 gap-4">
        <Input
          {...register("giftCode")}
          label={intl.ENTER_CODE}
          className="w-4/5"
          type="text"
          id="giftcard-input"
          valid={isSuccess}
        />

        <Button
          loading={isLoading}
          primary
          type="submit"
          className="grow whitespace-nowrap"
          id="redeem-giftcard-btn"
        >
          {intl.REDEEM}
        </Button>
      </div>
    </form>
  );
};
